<template>
  <section class="p-1">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">Transaction Analysis Report</div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-form ref="form" v-model="valid" class="px-2">
            <v-row class="px-2">
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filterList.fromdate"
                  label="From Date"
                  :rules="FieldRequired('From Date')"
                  @input="filterList.fromdate"
                  type="date"
                  dense
                  outlined
                  class="rounded"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filterList.todate"
                  type="date"
                  :rules="FieldRequired('To Date')"
                  label="To Date"
                  dense
                  outlined
                  class="rounded"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-text-field
                  placeholder="Customer Name"
                  v-model="filterList.customer_name"
                  label="Customer Name"
                  dense
                  outlined
                  class="rounded"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  class="rounded"
                  label="Country"
                  dense
                  outlined
                  :items="CountryList"
                  item-text="text"
                  item-value="value"
                  v-model="filterList.country"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  v-model="filterList.payment_mode"
                  class="rounded"
                  label="Payment Mode"
                  dense
                  outlined
                  item-text="txt"
                  item-value="val"
                  :items="method_options"
                  placeholder="Payout Partner"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  v-model="filterList.kyc_type"
                  class="rounded"
                  label="KYC Type"
                  dense
                  outlined
                  item-text="txt"
                  item-value="val"
                  :items="KYCType"
                  placeholder="KYC Type"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  v-model="filterList.channel_type"
                  class="rounded"
                  label="Service Mode"
                  dense
                  outlined
                  item-text="txt"
                  item-value="val"
                  :items="ServiceMode"
                  placeholder="Service Mode"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  v-model="filterList.report_type"
                  class="rounded"
                  label="Report Type"
                  dense
                  outlined
                  item-text="value"
                  item-value="value_code"
                  :items="TxnReport"
                  placeholder="Report Type"
                ></v-autocomplete>
              </v-col>
              <v-row class="ma-1 px-1 mt-0 mb-2">
                <v-btn
                  depressed
                  @click="getReportResults()"
                  color="primary"
                  small
                  >Get Results
                </v-btn>
              </v-row>
            </v-row>
          </v-form>
        </v-card>
      </v-card-text>
      <v-row class="ma-1 px-2 mt-2">
        <v-btn
          depressed
          @click="downloadExcelsheet"
          class="mt-1"
          color="primary"
          small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          placeholder="Type here to filter values."
          hide-details
          rounded
          outlined
          dense
          clearable
          class="mt-2"
        ></v-text-field>
      </v-row>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        :items="userList"
        :search="search"
        :loading="loaderOverlay"
        loading-text="Loading please wait...."
        no-data-text="No data available."
        item-key="Pin_Number"
        dense
        class="mt-3"
      >
      </v-data-table>
    </v-card>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { FieldRequired } from "@/utils/validation.js";
import alerts from "@/mixins/alerts";
import reportingService from "@/services/ReportingService/reportingService.js";
import commonService from "@/services/CommonService/commonService.js";
import {
  txn_analysis_method_options,
  txn_analysis_kyc_type,
  txn_analysis_report_type,
} from "@/utils/ConstantDropdowns/index.js";
export default {
  mixins: [alerts],
  name: "Transaction Analysis Report",
  data: () => {
    return {
      FieldRequired,
      CountryList: [],
      paymentMode: [],
      KYCType: txn_analysis_kyc_type,
      ServiceMode: [
        {
          txt: "All",
          val: 0,
        },
      ],
      TxnReport: txn_analysis_report_type,
      headers: [],
      totalpayoutPartnerDetails: [],
      filterList: {
        fromdate: new Date().toISOString().substr(0, 10),
        todate: new Date().toISOString().substr(0, 10),
        customer_name: "",
        country: "All",
        payment_mode: "A",
        kyc_type: "ALL",
        channel_type: 0,
        report_type: 0,
      },
      userList: [],
      senderPartners: [],
      payoutPartner: [],
      method_options: txn_analysis_method_options,
      search: "",
      userSelectedFilter: "Customer ID",
      loaderOverlay: false,
      valid: false,
    };
  },
  computed: {
    ...mapGetters(["getpreviouspageState"]),
    isPreviousState() {
      return this.getpreviouspageState;
    },
  },

  mounted() {
    this.getcountryList();
  },

  methods: {
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(
          this.headers,
          this.userList,
          "V3 Transaction Report"
        );
      }
    },
    FilterpartnerPaymentMode(partner_code) {
      this.totalpayoutPartnerDetails.map((ele) => {
        if (ele.partner_code == partner_code) {
          this.partnerPaymentMode(ele.partner_id);
        }
      });
    },
    async getReportResults() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.loaderOverlay = true;
        try {
          const response = await reportingService.gettxnAnalysisReport(
            this.filterList
          );
          if (response.status === 200) {
            this.loaderOverlay = false;
            const ObjKeys = Object.keys(response.data.data[0]);
            this.headers = ObjKeys.map((ele) => {
              return {
                text: ele,
                value: ele,
                sortable: false,
              };
            });
            this.userList = response.data.data;
          } else {
            this.loaderOverlay = false;
          }
        } catch (error) {
          this.loaderOverlay = false;
          console.error(error);
        }
      }
    },
    async getcountryList() {
      try {
        const response = await commonService.getdropdowns();
        if (response.data.status_code === 200) {
          this.CountryList = response.data.data.map((i) => {
            return { text: i.country_name, value: i.iso_alpha3 };
          });
          this.CountryList.unshift({
            text: "All",
            value: "All",
          });
          console.log("CountryList", this.CountryList);
        } else {
          this.CountryList == [];
        }
      } catch (error) {
        this.CountryList = [];
        console.error(error);
      }
    },
    async getPaymentMode() {
      try {
        const responseData = await commonService.getparameterdropdowns("PTY");
        if (responseData.data.status_code === 200) {
          this.paymentMode = responseData.data.data.map((e) => {
            return { name: e.value, id: e.value_code };
          });
        }

        console.log("getPaymentMode ", responseData);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px !important;
  min-width: 64px !important;
  padding: 0 16px !important;
}
.select-width {
  max-width: 60px;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
